<app-breadcrumb
  [title]="'Personas'"
  [items]="['Personas']"
  [active_item]="'Nuevo'"
></app-breadcrumb>
<div class="col-sm-12 col-xl-12">
  <ngb-accordion [closeOthers]="true" ac tiveIds="static-1">
    <ngb-panel id="static-1">
      <ng-template ngbPanelTitle>
        <i class="fa fa-info-circle"></i>
        <span class="ms-2">Generar planos</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-body">
            <form
              class="needs-validation"
              novalidate
              [ngClass]="{ 'was-validated': validate }"
            >
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01"
                    >NIT</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom02"
                    type="text"
                    placeholder="Last name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Razon social</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom02"
                    type="text"
                    placeholder="Last name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Dirección</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom02"
                    type="text"
                    placeholder="Last name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Telefono</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom01"
                    type="text"
                    placeholder="First name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
              </div>



              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01"
                    >E-mail</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom01"
                    type="text"
                    placeholder="First name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Fecha corte - expedición</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom02"
                    type="text"
                    placeholder="Last name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Tipos de acción</label
                  >
                  <ng-select
                  [items]="TiposAccion"
                  bindLabel="label"
                  bindValue="value"
                  placeholder="Seleciona una opción"
                  class="js-example-placeholder-multiple"
                  [(ngModel)]="tipoaccion"
                >
                </ng-select>
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Fecha inicio</label
                  >
                  <div class="input-group input-group-sm">
                    <input
                      class="form-control"
                      placeholder="yyyy-mm-dd"
                      name="dp"
                      [(ngModel)]="model2"
                      ngbDatepicker
                      #d3="ngbDatepicker"
                      [placement]="placement"
                      [positionTarget]="buttonEl"
                      [autoClose]="'outside'"
                    />
                    <button
                      #buttonEl
                      class="btn btn-primary calendar"
                      (click)="d3.toggle()"
                      type="button"
                    >
                      <app-feather-icons
                        [icon]="'calendar'"
                      ></app-feather-icons>
                    </button>
                  </div>
                  <div class="valid-feedback">Looks good!</div>
                </div>
              </div>


              <div class="row g-3 mb-3">
                <div class="col-md-3">
                    <label class="form-label" for="validationCustom02"
                      >Fecha Final</label
                    >
                    <div class="input-group input-group-sm">
                      <input
                        class="form-control"
                        placeholder="yyyy-mm-dd"
                        name="dp"
                        [(ngModel)]="model2"
                        ngbDatepicker
                        #d3="ngbDatepicker"
                        [placement]="placement"
                        [positionTarget]="buttonEl"
                        [autoClose]="'outside'"
                      />
                      <button
                        #buttonEl
                        class="btn btn-primary calendar"
                        (click)="d3.toggle()"
                        type="button"
                      >
                        <app-feather-icons
                          [icon]="'calendar'"
                        ></app-feather-icons>
                      </button>
                    </div>
                    <div class="valid-feedback">Looks good!</div>
                  </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Duración contrato (Meses)</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="number"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                    <label class="form-label" for="validationCustom02"
                      >Tipos de contrato</label
                    >
                    <ng-select
                    [items]="Tipocontrato"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple"
                    [(ngModel)]="tipocontrato"
                  >
                  </ng-select>
                    <div class="valid-feedback">Looks good!</div>
                  </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Numero de contrato</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="number"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
                  <div class="valid-feedback">Looks good!</div>
                </div>
              </div>


              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    Nombre de representante legal</label
                  >
                  <ng-select
                    [items]="TipoDeSangre"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple"
                    [(ngModel)]="Sangre"
                  >
                  </ng-select>
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02">
                    Placa del vehiculo</label
                  >
                  <input
                    class="form-control"
                    id="validationCustom02"
                    type="text"
                    placeholder="Last name"
                    required=""
                    onlyAlphabets
                  />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02">
                    Tipo de vehiculo</label
                  >
                  <ng-select
                    [items]="Tipovehiculo"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple"
                    [(ngModel)]="tipovehiculo"
                  >
                  </ng-select>
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                    <label class="form-label" for="validationCustom01">
                      Validación de firma</label
                    >
                    <input
                    class="form-control"
                    id="validationCustom02"
                    type="text"
                    placeholder="Last name"
                    required=""
                    onlyAlphabets
                  />
                    <div class="valid-feedback">Looks good!</div>
                  </div>
              </div>


            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>

    <ngb-panel id="static-2">
      <ng-template ngbPanelTitle>
        <i class="fa fa-user"></i
        ><!-- Ícono (puedes cambiar la clase) -->
        <span class="ms-2">Datos del propietario</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div class="card">
          <div class="card-header">
            <form
              class="needs-validation"
              novalidate
              [ngClass]="{ 'was-validated': validate }"
            >
              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    Tipo documento</label
                  >
                  <ng-select
                    [items]="Tipodocumento"
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Seleciona una opción"
                    class="js-example-placeholder-multiple"
                    [(ngModel)]="tipodocumento"
                  >
                  </ng-select>
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02">
                    Cargo del empleado</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="number"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02">
                   Nombre de propietario</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="text"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02">
                    Dirección de propietario</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="text"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
                </div>
              </div>


              <div class="row g-3 mb-3">
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom01">
                    Teléfono de propietario</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="text"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
               
                  <div class="valid-feedback">Looks good!</div>
                </div>
                <div class="col-md-3">
                  <label class="form-label" for="validationCustom02"
                    >Email de propietario</label
                  >
                  <input
                  class="form-control"
                  id="validationCustom02"
                  type="text"
                  placeholder="Last name"
                  required=""
                  onlyAlphabets
                />
                  <div class="valid-feedback">Looks good!</div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </ng-template>
    </ngb-panel>



    <!--
    <ngb-panel id="static-3" title="Disabled" [disabled]="true">
      <ng-template ngbPanelContent>
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf
        moon officia
        aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf
        moon tempor,
        sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim
        keffiyeh helvetica,
        craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
        Leggings
        occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them
        accusamus
        labore sustainable VHS.
      </ng-template>
    </ngb-panel>
-->
  </ngb-accordion>
</div>

<div class="btn-showcase my-4">
  <button type="button" class="btn btn-primary" (click)="withConfirmation()">Descargar</button>
  </div>


